import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const projectListSlice = createSlice({
  name: "projectList",
  initialState,
  reducers: {
    updateProjectList: (state, action) => {
      return {
        ...state,

        [action.payload.date]: action.payload.data,
      };
    },
  },
});

export const { updateProjectList } = projectListSlice.actions;

export default projectListSlice.reducer;
